import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import { generalAlertError } from '../../common/utils/alerts';
import { listReplacements, resetReplacements } from '../../features/afterSale/afterSaleActions';
import Pagination from '../../common/components/elements/Pagination';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
import { after_sale_purchase_statues } from '../../common/constants';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackReplacements } from '../../common/utils/joyrideCallbacks';
// import { replacementsSteps } from '../../common/utils/joyrideSteps';
import {
  ReplacementsPageStyles,
  PageHeader,
  HeaderActions,
  ReplacementCard,
  StatusBadge,
  ActionButton,
  FilterCard,
  SearchButton,
  EmptyState,
  LoadingState,
  ReplacementsList,
  InfoChip,
  PostSaleButton,
} from './ReplacementsPage.styles';

export function ReplacmentsPage() {
  const navigate = useNavigate();
  const state = useSelector((store) => store.afterSale.replacements_page);

  const {
    loading, replacements, page_number, total_pages, error,
  } = state;

  const [search, setSearch] = useState({
    search: '',
    date_from: '',
    date_to: '',
    vehicle_plate: '',
  });
  // const [steps, setSteps] = useState([]);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('replacements') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('replacements')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('replacements');
  //   setState({ run: true, tourActive: true });
  // };

  // useEffect(() => {
  //   replacementsSteps(replacements, setSteps);
  // }, [replacements]);

  useEffect(() => {
    (async () => {
      listReplacements(1, search);
    })();

    return () => {
      resetReplacements();
    };
  }, []);

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  const searchHandler = async (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      search: search.search.trim(),
    };

    listReplacements(1, trimmedSearch);
  };

  return error === null ? (
    <ReplacementsPageStyles>
      {/* <Joyride
        steps={steps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,
          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackReplacements(data, steps, setState)}
        showSkipButton
        showProgress
      /> */}
      <div className="container-fluid">
        <PageHeader>
          <h2>🔄 Sostituzioni</h2>
          <HeaderActions>
            <PostSaleButton onClick={() => navigate('/after-sale/select')}>
              Vai a Post Vendita
            </PostSaleButton>
            {/* {localStorage.getItem('replacements') === 'done' && (
              <PostSaleButton onClick={() => fireNewQuoteTour()}>
                Tutorial
              </PostSaleButton>
            )} */}
          </HeaderActions>
        </PageHeader>

        <div className="row">
          {/* Main Content */}
          <div className="col-lg-7 col-xl-8 col-xxl-9 order-2 order-lg-1">
            {loading ? (
              <LoadingState className="replacements-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento sostituzioni in corso...</span>
              </LoadingState>
            ) : (
              <>
                <ReplacementsList className="replacements-one">
                  {replacements.length > 0 ? (
                    replacements.map((replacement) => (
                      <ReplacementCard
                        key={replacement.id}
                        className="replacements-two"
                      >
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-2">
                          <div className="replacement-content">
                            <div className="customer-name">
                              👤
                              {' '}
                              {replacement.quotation.insurance_request.customer.gender !== 'G'
                                ? `${replacement.quotation.insurance_request.customer.name} ${replacement.quotation.insurance_request.customer.surname}`
                                : replacement.quotation.insurance_request.customer.business_name}
                            </div>

                            <div className="replacement-details">
                              <div className="detail-row">
                                <StatusBadge>
                                  {after_sale_purchase_statues.find((status) => status.id == replacement.status)?.name}
                                </StatusBadge>
                              </div>

                              <div className="info-chips-row">
                                {replacement.quotation.insurance_request.product && (
                                  <InfoChip $highlight>
                                    📦
                                    {' '}
                                    {replacement.quotation.insurance_request.product.name}
                                  </InfoChip>
                                )}

                                {replacement.quotation.company && (
                                  <InfoChip>
                                    🏢
                                    {' '}
                                    {replacement.quotation.company.name}
                                  </InfoChip>
                                )}

                                {(replacement.quotation.insurance_request.vehicle
                                  && replacement.quotation.insurance_request.vehicle.vehicle_plate !== null) && (
                                    <InfoChip $highlight>
                                      🚗 Targa:
                                      {' '}
                                      {replacement.quotation.insurance_request.vehicle.vehicle_plate}
                                    </InfoChip>
                                )}

                                {(replacement.quotation.insurance_request.vehicle
                                  && replacement.quotation.insurance_request.vehicle.old_vehicle_plate !== null) && (
                                    <InfoChip>
                                      🔖 Vecchia Targa:
                                      {' '}
                                      {replacement.quotation.insurance_request.vehicle.old_vehicle_plate}
                                    </InfoChip>
                                )}

                                {(replacement.quotation.insurance_request.moto
                                  && replacement.quotation.insurance_request.moto.moto_plate !== null) && (
                                    <InfoChip $highlight>
                                      🏍️
                                      {' '}
                                      {replacement.quotation.insurance_request.moto.moto_plate}
                                    </InfoChip>
                                )}

                                {(replacement.quotation.insurance_request.moto
                                  && replacement.quotation.insurance_request.moto.old_moto_plate !== null) && (
                                    <InfoChip>
                                      🔖 Vecchia Targa:
                                      {' '}
                                      {replacement.quotation.insurance_request.moto.old_moto_plate}
                                    </InfoChip>
                                )}
                              </div>

                              <div className="created-date">
                                🕐 Creato il
                                {' '}
                                {new Date(replacement.created_at).toLocaleDateString('it-IT', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center">
                            {replacement.status === 5 ? (
                              <Link to={`/replacements/${replacement.id}`}>
                                <ActionButton>
                                  📋 Vai a sostituzione
                                </ActionButton>
                              </Link>
                            ) : (
                              <Link to={`/after-sale/purchase/replacement/${replacement.id}`}>
                                <ActionButton>
                                  📋 Vai a sostituzione
                                </ActionButton>
                              </Link>
                            )}
                          </div>
                        </div>
                      </ReplacementCard>
                    ))
                  ) : (
                    <EmptyState className="replacements-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Nessuna sostituzione trovata!</h5>
                      <p>Prova a modificare i filtri di ricerca</p>
                    </EmptyState>
                  )}
                </ReplacementsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listReplacements}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>

          {/* Filters Sidebar */}
          <div className="col-lg-5 col-xl-4 col-xxl-3 order-1 order-lg-2 mb-4 mb-lg-0">
            <FilterCard className="replacements-three">
              <h5>🔍 Filtri di Ricerca</h5>
              <form
                onSubmit={searchHandler}
                className="d-flex flex-column gap-3"
              >
                <div>
                  <label htmlFor="search">Ricerca cliente</label>
                  <input
                    type="text"
                    name="search"
                    id="search"
                    className="form-control"
                    value={search.search}
                    onChange={handleChange}
                    placeholder="Nome, cognome..."
                  />
                </div>

                <div>
                  <label htmlFor="vehicle_plate">Ricerca targa</label>
                  <input
                    type="text"
                    name="vehicle_plate"
                    id="vehicle_plate"
                    className="form-control"
                    value={search.vehicle_plate}
                    onChange={handleChange}
                    placeholder="Targa..."
                  />
                </div>

                <div>
                  <label htmlFor="date_from">Data creazione da</label>
                  <input
                    type="date"
                    name="date_from"
                    id="date_from"
                    onChange={handleChange}
                    value={search.date_from}
                    className="form-control"
                    lang="it-IT"
                  />
                </div>

                <div>
                  <label htmlFor="date_to">Data creazione al</label>
                  <input
                    type="date"
                    name="date_to"
                    id="date_to"
                    className="form-control"
                    onChange={handleChange}
                    value={search.date_to}
                    min={search.date_from}
                    lang="it-IT"
                  />
                </div>

                <SearchButton type="submit">
                  Cerca
                </SearchButton>
              </form>
            </FilterCard>
          </div>
        </div>
      </div>
    </ReplacementsPageStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}
